module.exports = __webpack_public_path__ + "media/assets/images/category/CheerUp@2x-4edf63dc01df614f4a8c3aa51f15452d.png";